import { useMutation } from "@tanstack/react-query";
import { deactivateComo } from "../../api/bComoApi";

export const useDeactivateComo = () => {
  return useMutation({
    mutationKey: ["deactivate-como"],
    mutationFn: (data) => deactivateComo(data),
    onError: (error) => {
      console.error("Como deactivation error:", error.response || error);
    },
  });
};
